import React, { useCallback, useEffect, useState } from 'react';
import { useAuthenticated, useTranslate, Title, useDataProvider } from 'react-admin';
import moment from 'moment-timezone';
import { Box, Typography, Grid, ListItem, Button, Card, FormControlLabel, CircularProgress, TextField } from '@material-ui/core';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar'
import { makeStyles } from "@material-ui/core/styles";
import StartCalendar from '../common/DatePicker/startCalendar'
import colors from '../CustomizedUIs/Colors'
import TableFiles from '../systemData/tableSeverLog';
import Error from '../CustomizedUIs/Error'
import StopCalendar from '../common/DatePicker/stopCalendar';
import { Device, MessageAlarmProps, ResponseDevices } from '../types';

const useStyles = makeStyles({
    titleCommon: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    table: {
        minWidth: 700
    },
    titleSeverLog: {
        fontSize: '18px',
    },
    time: {
        fontSize: '13px',
        width: '100%',
        padding: 10,
    },
    timeText: {
        minHeight: 40,
        backgroundColor: 'rgb(255, 255, 255)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 5
    },
    text: {
        fontSize: '13px',
    },
    btnSelect: {
        fontSize: '11px',
        color: '#ffffff',
    }

});

const MessageAlarm = ({ roomID }: MessageAlarmProps) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();

    const [valueStartTime, setValueStartTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [valueStopTime, setValueStopTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [dateStart, setDateStart] = useState(new Date());
    const [dateStop, setDateStop] = useState(new Date());

    const [oldDateStop, setOldDateStop] = useState(new Date());
    const [oldDateStart, setOldDateStart] = useState(new Date());
    const [anchorElStopCalendar, setAnchorElStopCalendar] = React.useState<HTMLElement | null>(null);
    const [anchorElStartCalendar, setAnchorElStartCalendar] = React.useState(null);
    const [noEndDate, setNoEndDate] = useState<boolean>(false)
    const [event, setEvent] = useState("");
    const [device, setDevice] = useState<Partial<Device>>({});
    const [openEvent, setOpenEvent] = useState(false);
    const [openListDevice, setOpenListDevice] = useState(false);

    const [dataMessage, setDataMessage] = useState([]);
    const [devices, setDevices] = useState<Array<Device>>([]);

    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true)
    const [notData, setNoData] = useState(true);

    const dummyMessage = [
        { "event": "connect" },
        { "event": "keepalive" },
        { "event": "detect" },
        { "event": "lost" },
        { "event": "report" }
    ]

    const classes = useStyles();
    const onChangeEvent = (value: string) => {
        setEvent(value)
        setOpenEvent(false)
    };

    const onChangeListDevice = (value: Device) => {
        setDevice(value);
        setOpenListDevice(false);
    }

    const handleClickOpenLogLevel = () => {
        if (openListDevice) {
            setOpenListDevice(false)
        }
        setOpenEvent(!openEvent);
    }

    const handleClickOpenListDevice = () => {
        if (openEvent) {
            setOpenEvent(false)
        }
        setOpenListDevice(!openListDevice);
    }

    const SearchLog = () => {
        setLoading(true)
        setDataMessage([])

        dataProvider('GET_LIST', 'mqttmessage', {
            filter:
                Object.keys(device).length > 0
                    ? {
                        identify: device.id,
                        dateStart: dateStart.getTime(),
                        dateStop: dateStop.getTime(),
                    }
                    : event.length > 0
                        ? {
                            type: translate(event).replace(/\s+/g, '').toLowerCase(),
                            dateStart: dateStart.getTime(),
                            dateStop: dateStop.getTime(),

                        }
                        : {
                            dateStart: dateStart.getTime(),
                            dateStop: dateStop.getTime(),

                        },
            pagination: {
                perPage: 1,
                page: -1
            },
            sort: { field: 'id', order: 'ASC' },
        }).then((response: any) => {
            const { data } = response
            if (data && data.length > 0) {
                setNoData(false);
            } else {
                setNoData(true);
            }
            setDataMessage(data);
            setLoading(false);
        }).catch((error: any) => {
            setLoading(false)
            // TODO: Should show error message 
            console.log('Submit user error:', error);
        });
    }
    //event select of Stop Calendar

    const loadMore = useCallback(() => {

        if (Object.keys(dataMessage[dataMessage.length - 1]).length > 0) {
            const { id } = dataMessage[dataMessage.length - 1];
            if (id) {
                dataProvider('GET_LIST', 'mqttmessage', {
                    filter:
                        Object.keys(device).length > 0
                            ? {
                                identify: device.id,
                                dateStart: dateStart.getTime(),
                                dateStop: dateStop.getTime(),
                                lastID: id
                            }
                            : event.length > 0
                                ? {
                                    type: translate(event).replace(/\s+/g, '').toLowerCase(),
                                    dateStart: dateStart.getTime(),
                                    dateStop: dateStop.getTime(),
                                    lastID: id
                                }
                                : {
                                    dateStart: dateStart.getTime(),
                                    dateStop: dateStop.getTime(),
                                    lastID: id
                                },
                    pagination: {
                        perPage: 1,
                        page: -1
                    },
                    sort: { field: 'id', order: 'ASC' },
                }).then(({ data }: any) => {
                    if (data && data.length > 0) {
                        setNoData(false);
                        setDataMessage(dataMessage.concat(data));
                    } else {
                        setLoading(false);
                    }
                }).catch((error: any) => {
                    setLoading(false)
                    // TODO: Should show error message 
                    console.log('Submit user error:', error);
                });
            }
        } else {
            setHasMore(false)
        }
    }, [dataMessage])

    const handleClickStopCalendar = (event: React.MouseEvent<HTMLElement>) => {
        if (anchorElStopCalendar == null) {
            setAnchorElStopCalendar(event.currentTarget)
        }
        else {
            handleCloseStopCalendar()
            setAnchorElStopCalendar(null)
        }

    };

    const handleCloseStopCalendar = () => {
        setDateStop(oldDateStop)
        setAnchorElStopCalendar(null);
        setNoEndDate(valueStopTime == translate(`resources.room.onGoing`))
    };


    const onChangNoEndDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNoEndDate(event.target.checked)
    }



    const finishPickDateStop = (date: any) => {
        setValueStopTime(noEndDate ? translate(`resources.room.onGoing`) : moment(date).format('YYYY-MM-DD'))
        setOldDateStop(date)
        setAnchorElStopCalendar(null);
    };

    const onChangeStopCalendar = (date: any) => {
        setDateStop(date)
        finishPickDateStop(date)
    }

    const handleClickStartCalendar = (event: any) => {
        if (anchorElStartCalendar == null)
            setAnchorElStartCalendar(event.currentTarget)
        else {
            handleCloseStartCalendar()
            setAnchorElStartCalendar(null)
        }
    };

    const handleCloseStartCalendar = () => {
        setDateStart(oldDateStart)
        setAnchorElStartCalendar(null);
    };

    const finishPickDate = (date: any) => {
        setValueStartTime(moment(date).format('YYYY-MM-DD'))
        if (date.getTime() > dateStop.getTime() && valueStopTime != translate(`resources.room.onGoing`)) {
            setDateStop(date)
            setValueStopTime((moment(date).format('YYYY-MM-DD')))
        }
        setOldDateStart(date)
        setAnchorElStartCalendar(null);
    };

    const onChangeStartCalendar = (date: any) => {
        setDateStart(date)
        finishPickDate(date)
    }

    const onChangePickerStart = (e: any) => {
        if (!e.target.value) return
        let timeStart = (e.target.value).split(':')
        let newDateStart = dateStart
        newDateStart.setHours(timeStart[0], timeStart[1], timeStart[2])
        setDateStart(newDateStart)
    }

    const onChangePickerStop = (e: any) => {
        if (!e.target.value) return
        let timeStop = (e.target.value).split(':')
        let newDateStop = dateStop
        newDateStop.setHours(Number(timeStop[0]), Number(timeStop[1]), Number(timeStop[2]))
        setDateStop(newDateStop)
    }

    useEffect(() => {
        if (roomID) {
            dataProvider('GET_LIST', "devicesbyroom", {
                filter: {
                    room: roomID
                },
                pagination: {},
                sort: {},
            }).then((response: ResponseDevices) => {
                const { data } = response;
                if (data && data.length > 0) {
                    setDevices(data);
                }
            }).catch((error: any) => {
            });
        }
    }, [roomID]);

    useEffect(() => {
        let newDate = new Date();
        newDate.setHours(23, 59, 59);
        setDateStop(newDate);
        setOldDateStop(newDate);
    }, [])

    return (
        <Box width="100%">
            <Title title="{translate(`pos.user.title`)}" />
            <Box display='flex' width='100%' justifyContent='center'>
                <Box my={2} style={{ width: "500px" }} >
                    <Typography className={`${classes.titleCommon} ${classes.titleSeverLog}`} >{translate(`resources.messageAlarm.messageAlarmTitle`)}</Typography>
                    <Box display='flex'
                        justifyItems='center'
                        py={2}
                        my={1}
                        bgcolor={colors.white['50']}
                        border={1}
                        borderColor={colors.lightBlue['200']}
                        borderRadius='4px' >
                        <Box mx='auto' width='469px' style={{ gap: 10, display: 'flex', flexDirection: 'column' }}>
                            <Typography className={classes.titleCommon}>{translate(`resources.messageAlarm.messageAlarmDateTime`)}</Typography>
                            <Grid
                                container
                                justifyContent="space-between"
                                alignItems="center"
                                spacing={1}
                            >
                                <Grid
                                    container
                                    item
                                    xs={11}
                                    spacing={1}
                                >
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <StartCalendar
                                            anchorEl={anchorElStartCalendar}
                                            handleClick={handleClickStartCalendar}
                                            handleClose={handleClickStartCalendar}
                                            handleDateChange={onChangeStartCalendar}
                                            finishPickDate={finishPickDate}
                                            value={valueStartTime}
                                            date={dateStart}
                                            Title={translate(`resources.room.from`)}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <StopCalendar
                                            isNoEndDate={noEndDate}
                                            onChangNoEndDate={onChangNoEndDate}
                                            minDate={valueStartTime}
                                            anchorEl={anchorElStopCalendar}
                                            handleClick={handleClickStopCalendar}
                                            handleClose={handleClickStopCalendar}
                                            handleDateChange={onChangeStopCalendar}
                                            finishPickDate={finishPickDateStop}
                                            value={valueStopTime}
                                            date={dateStop}
                                            Title={translate(`resources.room.to`)}
                                            play={null}
                                            hideNoEndDate={null}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    xs={1}
                                >
                                    <CustomPoper
                                        isNotInfoPage={true}
                                        title={translate(`resources.messageAlarm.messageAlarmTitle`)}
                                        content={translate(`resources.messageAlarm.messageAlarmContent`)}
                                        icon={<b>?</b>}
                                        color={null}
                                        fontSize={null}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                spacing={1}
                                justifyContent='space-between'
                                alignItems='center'
                            >
                                <Grid
                                    item
                                    container
                                    xs={11}
                                    spacing={1}
                                >
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <TextField
                                            id="time"
                                            type="time"
                                            defaultValue={`${moment(dateStart).format('HH:mm:ss')}`}
                                            onChange={onChangePickerStart}
                                            inputProps={{
                                                step: 1, // 1 second,
                                                className: classes.time,

                                            }}
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                            fullWidth
                                            className={classes.timeText}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <TextField
                                            id="time"
                                            type="time"
                                            defaultValue={`${moment(dateStop).format('HH:mm:ss')}`}
                                            onChange={onChangePickerStop}
                                            inputProps={{
                                                step: 1, // 1 second
                                                className: classes.time
                                            }}
                                            InputProps={{
                                                disableUnderline: true,
                                                margin: 'dense'
                                            }}
                                            fullWidth
                                            className={classes.timeText}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    xs={1}
                                >
                                    <CustomPoper
                                        isNotInfoPage={true}
                                        title={translate(`resources.messageAlarm.messageAlarmTitle`)}
                                        content={translate(`resources.messageAlarm.messageAlarmContent`)}
                                        icon={<b>?</b>}
                                        color={null}
                                        fontSize={null}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    <Box
                        my={1}
                    >
                        <SelectBox
                            label={translate('resources.messageAlarm.messageAlarmLogLevel')}
                            value={
                                <Typography className={`${classes.titleCommon} ${classes.text}`}>
                                    {
                                        event.length === 0 ? "All" : translate(event)
                                    }
                                </Typography>
                            }
                            open={openEvent}
                            handleClick={handleClickOpenLogLevel}
                            CreateBox={null}
                            bgcolor={null}
                            disabled={null}
                            filter={null}
                            header={null}
                            maxHeight={null}
                            required={null}
                        >
                            {
                                dummyMessage.map((item, index) => (
                                    <ListItem
                                        key={index}
                                        button
                                        onClick={() => onChangeEvent(`resources.messageAlarm.${item.event}`)}
                                    >
                                        <Typography className={`${classes.titleCommon} ${classes.text}`}>
                                            {
                                                translate(`resources.messageAlarm.${item.event}`)
                                            }
                                        </Typography>
                                    </ListItem>
                                ))
                            }
                        </SelectBox>
                    </Box>

                    <Box
                        my={1}
                    >
                        <SelectBox
                            label={translate('resources.messageAlarm.messageAlarmListDevices')}
                            value={

                                <Typography className={`${classes.titleCommon} ${classes.text}`}>
                                    {
                                        Object.keys(device).length === 0 ? "All" : device.name
                                    }
                                </Typography>
                            }
                            open={openListDevice}
                            handleClick={handleClickOpenListDevice}
                            CreateBox={null}
                            bgcolor={null}
                            disabled={null}
                            filter={null}
                            header={null}
                            maxHeight={null}
                            required={null}
                        >
                            {
                                devices.map((item, index) => (
                                    <ListItem
                                        key={index}
                                        button
                                        onClick={() => onChangeListDevice(item)}
                                    >
                                        <Typography className={`${classes.titleCommon} ${classes.text}`}>
                                            {
                                                item.name
                                            }
                                        </Typography>
                                    </ListItem>
                                ))
                            }
                        </SelectBox>
                    </Box>
                    <Box mt={3} display='flex' justifyContent='flex-end'>
                        <Button
                            disabled={loading}
                            variant="contained"
                            color='primary'
                            style={{ width: '94px', height: '36px' }}
                            onClick={SearchLog}
                        >
                            {loading ? (
                                <CircularProgress
                                    size={20}
                                    thickness={2}
                                    color='inherit'
                                />
                            ) : <Typography className={`${classes.titleCommon} ${classes.btnSelect}`}>{translate('resources.messageAlarm.search')}</Typography>}
                        </Button>
                    </Box>
                </Box>
            </Box>
            <Box style={{ padding: 63 }} >
                {
                    notData ?
                        <Box display='flex' width='100%' justifyContent='center'>
                            <Typography style={{ textAlign: 'center', padding: 30 }} className={classes.titleSeverLog}>{translate('resources.severlog.nodata')}</Typography>
                        </Box>
                        :
                        dataMessage.length != 0 &&
                        <TableFiles
                            loadFunc={loadMore}
                            hasMore={hasMore}
                            categories={dataMessage}
                            alarmClock
                            loading={loading}
                        />
                }
            </Box>
        </Box >

    );
};

export default MessageAlarm;
